import Employee from '@/models/Employee';
import CheckBugSolver from '@/mixins/CheckBugSolver';

export default class RD extends Employee {
  constructor({ team, index, productivity }) {
    super({ team, index, productivity });
    this.addSkill(new CheckBugSolver(this));
  }
}
